import React, { useState, useEffect } from "react";
import leftArrow from '../Images/arrowleft.png'; 
import rightArrow from '../Images/arrowright.png'; 
import shoppingCart from '../Images/arrow-shop.png'; 
import massege from '../Images/arrow-massege.png'; 
import TrophyIcon from '../Images/cup.svg'; 
import TruckIcon from '../Images/car.svg'; 
import TagIcon from '../Images/wallet.png';
import RateImage from '../Images/rate.png';



const OnlinePrintingShop = () => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [freeSampleImage, setFreeSampleImage] = useState('');

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await fetch('https://backend.printtrio.co.uk/api/home/get-setting', {
          headers: { 'Accept': 'application/json' },
        });
        const result = await response.json();
        if (result.success && result.data.length > 0) {
          setFreeSampleImage(result.data[0].free_sample_image);
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, []);

  const slides = [
    (
      <div className="px-6 flex flex-col md:flex-row justify-between items-center "
      style={{
        backgroundImage: `url(${freeSampleImage})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        aspectRatio: '16 / 6',
      }}
       >

<div className="flex-1  mr-44 md:mr-0 mt-10 ">
              <h1 className="text-white font-bold text-sm md:text-4xl  mb-2 md:mb-8 xl:mb-20 lg:px-16 w-40 md:w-full max-w-2xl">
       Request a free sample pack to get the feel
       and the quality of our printing services
        </h1>
        {/* <p className="text-white text-opacity-80 mb-6 px-0 xl:px-20">
          Lorem Ipsum Dolor Sit Amet Consectetur. Dolor Cursus <br /> Mattis Rhoncus Natoque Risus Proin Pharetra Lacus Vitae.
        </p>
 */}

      </div>

    </div>
    ),

];

const nextSlide = () => setCurrentSlide((currentSlide + 1) % slides.length);

  // Function to navigate to the previous slide
  const prevSlide = () => setCurrentSlide((currentSlide - 1 + slides.length) % slides.length);


  return (
    <>    
    <div className="w-full bg-white">
   <div className="max-w-screen-xl mx-auto relative">
 


      {slides[currentSlide]}


    



      <div className="flex items-center justify-end space-x-2">
  {slides.map((_, index) => (
    <span key={index}
          style={{
            width: currentSlide === index ? '20px' : '8px',
            backgroundColor: currentSlide === index ? '#ec008c' : 'white',
            opacity: currentSlide === index ? '2' : '0.5',
          }}
          
    ></span>
  ))}
</div>




    </div>

    </div>
    <div className="flex flex-col  md:flex-row justify-between items-start md:items-center  px-20 md:px-16 xl:px-48 space-y-12 md:space-y-0  bg-white py-8 md:py-8 max-w-screen-2xl mx-auto px-4 xl:px-20">
      <div className="flex flex-row items-center gap-4 pl-0 md:pl-1">
        <img src={TrophyIcon} alt="Premium Quality" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl  mt-2">Premium Quality Made In The UK</p>
      </div>
      <div className="flex flex-row items-center gap-4">
        <img src={TruckIcon} alt="Fast Delivery" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Fast Production And Delivery</p>
      </div>
      <div className="flex flex-row items-center gap-4 ">
        <img src={TagIcon} alt="Low Price" className="h-8 w-8" />
        <p className="text-black text-xs xl:text-xl mt-2">Low Price And Low Quantity Orders</p>
      </div>
    </div>


  

    </>

  );
};

export default OnlinePrintingShop;
